import ApplicationController from './application_controller.js'

export default class extends ApplicationController {
  static classes = ['style']
  static targets = ['element']

  toggle() {
    if (this.elementTarget.classList.contains(this.styleClass)) {
      this.#remove()
    } else {
      this.#add()
    }
  }

  #remove() {
    this.elementTarget.classList.remove(this.styleClass)
  }

  #add() {
    this.elementTarget.classList.add(this.styleClass)
  }
}
